<template>
	<div>
		<loading-overlay :active.sync="loading"/>

		<div id="cancelBidModal" aria-hidden="true" aria-labelledby="cancelBidModalLabel" class="modal fade"
		     data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
				<div class="modal-content rounded-4 bg-primary">
					<div class="modal-header p-4 border-0 justify-content-between align-items-start">
                        <div>
                            <h5 id="cancelBidModalLabel" class="modal-title mb-3 fs-24 fw-bold">
                                <span v-if="offerType === 'buy'">Cancel Bid Offer</span>
                                <span v-else-if="offerType === 'sell'">Cancel Sell Offer</span>
                            </h5>
                            <p  v-if="qrCode || signLink" class="mb-0 text-grey-200">
                                A notification has been sent to your mobile application. Open the Xumm
                                Application on your device to complete the transaction.
                            </p>
                            <p v-else class="mb-0 text-grey-200">
                                You are about to cancel your current offer for
                                <b v-if="selectedOffer && offerInXrp(selectedOffer.amount)">
                                    {{ convertDropsToXrp(selectedOffer.amount) }} ({{ getValueInHadaCurrency(selectedOffer.amount) }})
                                </b>
                                <b v-else-if="selectedOffer">
                                    {{ getValueInHadaCurrency(selectedOffer.amount) }}
                                </b>
                                . Please confirm.
                            </p>
                        </div>
                        <svg width="24" height="24" class="flex-shrink-0" data-bs-dismiss="modal"
                             type="button">
                            <use xlink:href="#close-icon"></use>
                        </svg>
					</div>
                    <div class="modal-body p-4 pb-6 text-center">
                        <template v-if="qrCode || signLink">
                            <p>Or scan the QR code below:</p>
                            <img :src="qrCode" :alt="signLink"/>

                            <p class="mt-5 mb-0 text-white">You can use the following link to complete the same transaction: <a class="text-white" :href="signLink">{{ signLink }}</a></p>
                        </template>
                        <template v-else>
                        <div :class="['selected-puzzle-piece rounded overflow-hidden mb-8 mx-auto', puzzlePiece.type]">
                            <img :src="getImage(puzzlePiece.cid)" alt="Selected puzzle piece" class="h-100 w-100"/>
                        </div>
                        </template>
					</div>
					<div class="modal-footer border-0 pt-0 pb-4 px-4" v-if="!qrCode && !signLink">
						<button :disabled="loading" class="btn btn-primary-200 text-white whitespace-nowrap py-3 px-4 col-5 rounded-1 fs-18 fw-bold mx-auto" data-bs-dismiss="modal" type="button">
                            Cancel
						</button>
						<button v-if="offerType === 'buy'" :disabled="loading"
						        class="btn btn-secondary text-white whitespace-nowrap py-3 px-4 col-5 rounded-1 fs-18 fw-bold mx-auto" type="button" @click="removeBid()">
							Revoke Offer
						</button>
						<button v-else-if="offerType === 'sell'" :disabled="loading"
						        class="btn btn-secondary text-white whitespace-nowrap py-3 px-4 col-5 rounded-1 fs-18 fw-bold mx-auto" type="button" @click="removeSellOffer()">
							Continue
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CancelBidModal',

	props: {
		selectedOffer: Object,
		puzzlePiece: Object,
		offerType: String,
	},

	data() {
		return {
			loading: false,
			qrCode: null,
			signLink: null
		}
	},
	mounted() {
		$('#cancelBidModal').on('hide.bs.modal', () => {
			this.qrCode = null
			this.signLink = null
		})
	},
	methods: {
		removeBid: function () {
			this.loading = true
			axios.post(route('nft.offers.buy.cancel'), {
				selectedOffer: this.selectedOffer,
				puzzlePiece: this.puzzlePiece
			}).then(response => {
				this.qrCode = response.data.qrCode
				this.signLink = response.data.signLink
				let transactionId = response.data.pendingTransaction
				this.loading = false
				let intervalId = setInterval(() => {
					this.checkTransactionStatus(transactionId, intervalId)
				}, 4000)
			}).catch((error) => {
				this.loading = false
				Toast.fire({
					icon: 'error',
					title: error.data.message
				})
			})
		},

		removeSellOffer: function () {
			this.loading = true
			axios.post(route('nft.offers.sell.cancel'), {
				selectedOffer: this.selectedOffer,
				puzzlePiece: this.puzzlePiece
			}).then(response => {
				this.qrCode = response.data.qrCode
				this.signLink = response.data.signLink
				let transactionId = response.data.pendingTransaction
				this.loading = false
				let intervalId = setInterval(() => {
					this.checkTransactionStatus(transactionId, intervalId)
				}, 4000)
			}).catch((error) => {
				this.loading = false
				Toast.fire({
					icon: 'error',
					title: error.data.message
				})
			})
		},

		checkTransactionStatus: function (pendingTransactionId, intervalId) {
			axios.get(route('check-transaction-status', pendingTransactionId)).then(response => {
				if (!this.is_null(response.data.status)) {
					this.loading = false
					Toast.fire({
						icon: response.data.status,
						title: response.data.message
					})
					$('#cancelBidModal').modal('hide')
					this.$emit('transactionCompleted', response.data.status, 'bidCancelled')
					clearInterval(intervalId)
					axios.post(route('delete-pending-transaction', pendingTransactionId))
				}
			})
		},
	}
}
</script>
